export interface FeedbackIndicationContext {
  canStepForward: boolean;
  speCanFeedback: boolean;
  inSuperUserMode: boolean;
  currentStep: number;
  isStepRevise: boolean;
}

/**
 * Indica si el usuario tiene en pantalla las opciones de indicacion para elegir.
 * FlowFeedbackProvider oculta los radios cuando el especialista solo puede comentar,
 * salvo que este en modo superusuario y el paso no sea el primero ni uno de revise.
 */
export const canChooseIndication = (ctx: FeedbackIndicationContext): boolean =>
  ctx.canStepForward &&
  (!ctx.speCanFeedback ||
    (ctx.inSuperUserMode && !(ctx.currentStep === 1 || ctx.isStepRevise)));

/**
 * Indica si hay que conservar el boton "Send for Review" en lugar de mostrar "Apply".
 * Aplica cuando el especialista puede comentar pero no tiene como elegir una indicacion:
 * "Apply" exigiria una indicacion que la pantalla no ofrece y el flujo queda trabado.
 */
export const shouldKeepSendForReview = (ctx: FeedbackIndicationContext): boolean =>
  ctx.speCanFeedback && ctx.canStepForward && !canChooseIndication(ctx);
